import { useState } from 'react';
import { Send, Loader2 } from 'lucide-react';
import { base44 } from '@/api/base44Client';

const COUNTRIES = ['UAE', 'United States', 'Canada', 'Australia', 'Spain', 'Mexico', 'Other'];
const SERVICES = ['Custom AI', 'Website', 'Landing page', 'SaaS', 'Mobile app', 'Game', 'Business automation', 'Digital marketing', 'Cybersecurity', 'Not sure'];
const BUDGETS = ['Under $2,000', '$2,000–$5,000', '$5,000–$15,000', '$15,000–$50,000', '$50,000+', 'Not sure'];
const EMPTY = { name: '', email: '', company: '', phone: '', country: COUNTRIES[0], service: SERVICES[0], budget: BUDGETS[0], message: '' };
const field = 'w-full px-4 py-3 rounded-lg bg-secondary/50 border border-border/50 text-foreground font-inter text-sm placeholder:text-muted-foreground/50 focus:outline-none focus:border-primary/50 transition-all';
const label = 'text-xs font-inter font-medium tracking-[0.15em] uppercase text-muted-foreground mb-2 block';

export default function ProjectContactForm() {
  const [f, setF] = useState(EMPTY);
  const [state, setState] = useState('idle');
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setState('loading');
    try {
      await base44.functions.invoke('sendContactEmail', f);
      setF(EMPTY);
      setState('sent');
    } catch {
      setState('error');
    }
  };

  const sel = (k, opts, l) => (
    <div><label htmlFor={`pcf-${k}`} className={label}>{l}</label><select id={`pcf-${k}`} value={f[k]} onChange={set(k)} className={`${field} !bg-background hover:border-primary/40`}>{opts.map((o) => <option key={o}>{o}</option>)}</select></div>
  );

  return (
    <section id="contact-form" className="scroll-mt-24 max-w-4xl mx-auto px-6 lg:px-8 mt-12 pb-24">
      <h2 className="font-inter font-black text-2xl md:text-3xl text-foreground mb-6">Tell us about your project</h2>
      {state === 'sent' ? (
        <p className="rounded-2xl border border-primary/40 bg-card/40 p-6 text-foreground">Thank you — your message has been sent. We will reply within one business day.</p>
      ) : (
        <form onSubmit={submit} className="grid md:grid-cols-2 gap-5 rounded-2xl border border-border/50 bg-card/40 p-6 md:p-8">
          <div><label className={label}>Full name</label><input required value={f.name} onChange={set('name')} className={field} /></div>
          <div><label className={label}>Email</label><input type="email" required value={f.email} onChange={set('email')} className={field} /></div>
          <div><label className={label}>Company</label><input value={f.company} onChange={set('company')} className={field} /></div>
          <div><label className={label}>WhatsApp / phone (optional)</label><input value={f.phone} onChange={set('phone')} className={field} /></div>
          {sel('country', COUNTRIES, 'Country')}
          {sel('service', SERVICES, 'Service')}
          <div className="md:col-span-2">{sel('budget', BUDGETS, 'Budget')}</div>
          <div className="md:col-span-2"><label className={label}>Message</label><textarea required rows={4} value={f.message} onChange={set('message')} className={`${field} resize-none`} /></div>
          {state === 'error' && <p className="md:col-span-2 text-sm text-destructive">Failed to send. Please try again or email info@jotunheims.com.</p>}
          <button type="submit" disabled={state === 'loading'} className="md:col-span-2 py-4 bg-primary text-primary-foreground font-semibold text-sm tracking-wider uppercase rounded-lg hover:bg-primary/90 transition-all flex items-center justify-center gap-2 disabled:opacity-60">
            {state === 'loading' ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} Send message
          </button>
        </form>
      )}
    </section>
  );
}